export default __webpack_public_path__ + "assets/models/cef9fdb7f6b31cae0028864f20c6641c.glb";